<template>
  <main class="mx-2rem sm:w-lg sm:mx-auto">

    <Head>
      <Title>Posts</Title>
    </Head>

    <ContentList path="/posts">
      <template #default="{ list }">
        <div v-for="post in list.toReversed()" :key="post._path" class="pb-1rem">
          <h2 class="uppercase font-300">
            <NuxtLink :to="post._path">{{ post.title }}</NuxtLink>
          </h2>
          <p>{{ post.description }}</p>
        </div>
      </template>
      <template #not-found>
        <p>No posts here yet.</p>
      </template>
    </ContentList>
  </main>
  <Footer />
</template>
